export default __webpack_public_path__ + "static/media/clearIcon.912f69e4.svg";